// extracted by mini-css-extract-plugin
export default {"image":"SolarParksPage_image__SvS5e","remove":"SolarParksPage_remove__RQ4d8"};